import { TeacherPageContext, ViewMode } from './TeacherPageContextProvider';
import { useContext } from 'react';

export const ToggleViewModeButton = () => {
    const { toggleViewMode, viewMode, isOwner } = useContext(TeacherPageContext);

    if (!isOwner) {
        return null;
    }

    const label = viewMode === ViewMode.TEACHER
        ? 'View your profile as a donor'
        : 'Switch back to teacher view';

    return (
        <button type="button" className="toggle-view-mode-button subtle-link" onClick={toggleViewMode}>
            {label}
        </button>
    );
};
